import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Label, Input, Button, Modal } from "semantic-ui-react";
import allAxiosCommonTA from "./../axiosComponent/allAxiosCommonTA";
import cogoToast from "cogo-toast";

const AllotVehicle = ({ ...props }) => {

    const [modalOpen, setmodalOpen] = useState(false);

    useEffect(() => {
    }, []);

    let handleOpen = () => setmodalOpen(true);

    let handleClose = () => {
        setmodalOpen(false);
    };

    const onClick = (e) => {
        var dateformat = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        let vehicleAvailabilityId = props.data.vehicle_availability_id

        let freight_rate_input = 0;
        if (document.getElementById("freight_rate_input").value)
            freight_rate_input = parseInt(document.getElementById("freight_rate_input").value)

        let lrNO = props?.data?.lr_no;
        let lrDate = props?.data?.lr_date;

        if (!lrDate.match(dateformat)) {
            cogoToast.warn("Please provide correct LR Date");
        }

        if (lrDate.match(dateformat)) {
            let allot_details = {
                "lr_no": lrNO,
                "lr_date": lrDate,
                "vehicle_availability_id": vehicleAvailabilityId,
                "ownership_type_id": props.agGridReact.props.ownershipTypeId,
                "freight_rate": freight_rate_input
            };
            allAxiosCommonTA({
                url: "/bookings/indent/planning/allot", method: "post",
                Items: {
                    allot_details,
                    action_code: "ALLOT",
                    booking_id: props.agGridReact.props.bookingID,
                }
            })
                .then((response) => {
                    cogoToast.success(response.data.message)
                    window.location.reload()
                })
                .catch((err) => {
                    console.log("err", err);
                    cogoToast.error(err)
                });
        }

    };

    return (
        <>
            <Button
                className="width-100cent"
                onClick={e => handleOpen()}
                primary
            >
                Allot
            </Button>
            <div>
                <Modal open={modalOpen} onClose={handleClose} size="sm">
                    <Modal.Header className="p-bold-100">
                        <div className="d-flex justify-content-between">
                            <label className="font-weight-normal">{"Allot"}</label>
                            <div className="form-inline">
                                <i onClick={handleClose} className="fas fa-times"></i>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <div className="display-flex-center-justify-center">
                            <label>
                                Final Rate
                                <Input className="margin-left-20" type="number" id="freight_rate_input" />
                            </label>
                        </div>
                        <br /><br /><br />

                        <div className="display-flex-center-justify-spacebtwn">
                            <Button
                                onClick={handleClose}
                                primary
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={e => onClick(e)}
                                primary
                            >
                                Allot
                            </Button>
                        </div>
                    </Modal.Content>
                </Modal>
            </div>
        </>
    )
}

export default AllotVehicle;
